import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { getServiceErrorMessage } from "../../../helpers"
import { Context, Transitions } from "../../../types"

export const getResetClassMasteryLessonsAffectedCountTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  entry: assign<Context>({
    loading: true,
    currentClassMasteryLessonAffectedCount: null
  }),
  exit: assign<Context>({ loading: false }),
  invoke: {
    id: "getResetClassMasteryLessonsAffectedCount",
    src: "getResetClassMasteryLessonsAffectedCount",
    onDone: [
      {
        actions: assign<Context, DoneInvokeEvent<number>>((_ctx, evt) => ({
          currentClassMasteryLessonAffectedCount: evt?.data
        })),
        target: "idle"
      }
    ],
    onError: {
      target: "#StudyPlan.teacher_view.idle",
      actions: assign<
        Context,
        DoneInvokeEvent<{
          response: boolean
          contentId: string
          message: string
        }>
      >((_ctx, evt) => ({
        snackbar: {
          message: getServiceErrorMessage(
            "getResetClassMasteryLessonsAffectedCount",
            {
              errorReason: evt.data?.message
            }
          ),
          withUndo: false,
          error: true
        }
      }))
    }
  }
}
